module.exports = __webpack_public_path__ + "img/1373.297b53c2.gif";